var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0684,
    cy: 11.4658,
    r: 10,
    stroke: "#143CFE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94508 13.7231H11.5878V13.2538C11.6318 12.4325 12.3358 11.8311 13.0251 11.1711C13.6851 10.5258 14.3158 9.85113 14.3158 8.8098C14.3158 7.38713 13.3331 6.24313 11.2358 6.24313C9.27042 6.24313 7.90642 7.4458 7.80375 9.36713H9.50508C9.60775 8.35513 10.2384 7.7098 11.1478 7.7098C12.0424 7.7098 12.4531 8.1938 12.4531 8.9418C12.4531 9.57246 11.9691 10.0565 11.4264 10.5991C10.7224 11.2885 9.94508 12.0071 9.94508 13.1658V13.7231ZM10.7518 16.9791C11.3971 16.9791 11.9251 16.4805 11.9251 15.8498C11.9251 15.2045 11.3971 14.7058 10.7518 14.7058C10.0918 14.7058 9.54908 15.2045 9.54908 15.8498C9.54908 16.4805 10.0918 16.9791 10.7518 16.9791Z",
    fill: "#143CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.133bcd8ad5298da112e58f15898f6d00.svg";
export { ForwardRef as ReactComponent };